import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  AnswerTicket,
  DeleteTicket,
  EditTicketMessage,
  GetTicketDetails,
  GetTicketList,
} from "./ticket.api";

export const ticketKeys = {
  all: ["tickets"],
  lists: () => [...ticketKeys.all, "list"],
  list: (params) => [...ticketKeys.lists(), params],
  detail: (id) => [...ticketKeys.all, "detail", id],
};

export const useTicketListQuery = (params) =>
  useQuery({
    queryKey: ticketKeys.list(params),
    queryFn: () => GetTicketList(params),
  });

export const useTicketDetailsQuery = (id) =>
  useQuery({
    queryKey: ticketKeys.detail(id),
    queryFn: () => GetTicketDetails(id),
    enabled: Boolean(id),
  });

export const useAnswerTicketMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AnswerTicket,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ticketKeys.all });
    },
  });
};

export const useEditTicketMessageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: EditTicketMessage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ticketKeys.all });
    },
  });
};

export const useDeleteTicketMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DeleteTicket,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ticketKeys.all });
    },
  });
};
